import React from "react";
import { Link } from "react-router-dom";
import SectionShell from "./SectionShell";

const AUDIENCE = [
  "You own a term policy and quietly wonder if you should own something else.",
  "You bought life insurance a decade ago and haven't looked at it since.",
  "You're a business owner and no one has explained corporate life insurance properly.",
  "You've been told term is 'always cheaper', and something doesn't sit right.",
];

const STEPS = [
  ["Take the Scorecard", "15 short questions. No jargon, no signup."],
  ["Get your score", "Your Confidence Score out of 100 and your Prospera stage."],
  ["Talk it through", "An optional review with Biagio. No obligation."],
];

function ScorePreview() {
  return (
    <div
      className="rounded-2xl bg-white border border-[#E6E2D8] p-8 shadow-[0_30px_60px_-30px_rgba(11,31,63,0.25)]"
      data-testid="assessment-preview-card"
    >
      <div className="text-[11px] tracking-[0.3em] uppercase font-semibold text-[#8A6A2E]">
        Example result
      </div>
      <div className="font-display text-[#0B1F3F] text-xl mt-2">Your Confidence Score</div>
      <div className="mt-6 flex items-baseline gap-2">
        <span className="font-display text-[#0B1F3F] text-7xl tabular-nums">72</span>
        <span className="text-[#5A6476] text-sm">/ 100</span>
      </div>
      <div className="mt-4 h-1.5 rounded-full bg-[#F1EEE6] overflow-hidden">
        <div className="h-full w-[72%] bg-[#B08D57]" />
      </div>
      <div className="mt-6 rounded-xl bg-[#F7F5EF] p-5">
        <div className="text-[11px] tracking-[0.3em] uppercase font-semibold text-[#5A6476]">
          Your stage
        </div>
        <div className="font-display text-[#0B1F3F] text-lg mt-1">Recover: Money Back Life™</div>
        <p className="text-[#5A6476] text-sm mt-2 leading-relaxed">
          A strong candidate for permanent coverage where you pay for a limited
          number of years and receive the value back.
        </p>
      </div>
    </div>
  );
}

export default function AssessmentPitch() {
  return (
    <SectionShell
      id="assessment-pitch"
      eyebrow="The Confidence Scorecard"
      title="Are you sure you bought the right life insurance?"
      intro="Most Canadians find out too late. In three minutes, see where you stand, and what a smarter version of your current plan would look like."
      data-testid="assessment-pitch"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-7">
          <div className="text-[#0B1F3F] font-semibold text-sm">It's for you if…</div>
          <ul className="mt-5 divide-y divide-[#E6E2D8] border-y border-[#E6E2D8]" data-testid="assessment-audience">
            {AUDIENCE.map((line) => (
              <li key={line} className="py-4 text-[#0F1B2D] text-[15px] leading-relaxed">
                {line}
              </li>
            ))}
          </ul>

          <ol className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6" data-testid="assessment-steps">
            {STEPS.map(([t, b], i) => (
              <li key={t}>
                <div className="font-display italic text-[#B08D57] text-lg">0{i + 1}</div>
                <div className="text-[#0B1F3F] font-semibold mt-1">{t}</div>
                <p className="text-[#5A6476] text-sm mt-1 leading-relaxed">{b}</p>
              </li>
            ))}
          </ol>

          <div className="mt-10 flex flex-wrap items-center gap-5">
            <Link to="/assessment" className="btn-primary" data-testid="assessment-pitch-cta">
              Start the assessment
            </Link>
            <span className="text-[#5A6476] text-sm">3 minutes · Private · Instant result</span>
          </div>
        </div>
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <ScorePreview />
        </div>
      </div>
    </SectionShell>
  );
}
